export const USER_ROLES = ['ADMIN', 'USER'] as const
export type UserRole = (typeof USER_ROLES)[number]
export const USER_ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: 'אדמין',
  USER: 'משתמש',
}

export const CASE_TYPES = ['PROPERTY', 'WILL'] as const
export type CaseType = (typeof CASE_TYPES)[number]
export const CASE_TYPE_LABELS: Record<CaseType, string> = {
  PROPERTY: 'נכס',
  WILL: 'צוואה',
}

export const CASE_CLIENT_ROLES = ['SELLER', 'BUYER'] as const
export type CaseClientRole = (typeof CASE_CLIENT_ROLES)[number]
export const CASE_CLIENT_ROLE_LABELS: Record<CaseClientRole, string> = {
  SELLER: 'מוכר',
  BUYER: 'קונה',
}

export const TASK_STATUSES = [
  'TODO',
  'IN_PROGRESS',
  'WAITING_CLIENT',
  'WAITING_EXTERNAL',
  'DONE',
  'CANCELLED',
] as const
export type TaskStatus = (typeof TASK_STATUSES)[number]
export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  TODO: 'לביצוע',
  IN_PROGRESS: 'בטיפול',
  WAITING_CLIENT: 'ממתין ללקוח',
  WAITING_EXTERNAL: 'ממתין לגורם חיצוני',
  DONE: 'הושלם',
  CANCELLED: 'בוטל',
}

/** Statuses that still require attention — used by the dashboard and the due-soon job. */
export const OPEN_TASK_STATUSES = [
  'TODO',
  'IN_PROGRESS',
  'WAITING_CLIENT',
  'WAITING_EXTERNAL',
] as const satisfies readonly TaskStatus[]

export const TASK_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'] as const
export type TaskPriority = (typeof TASK_PRIORITIES)[number]
export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  LOW: 'נמוכה',
  MEDIUM: 'בינונית',
  HIGH: 'גבוהה',
  URGENT: 'דחוף',
}

export const NOTIFICATION_TYPES = ['TASK_ASSIGNED', 'TASK_DUE_SOON'] as const
export type NotificationType = (typeof NOTIFICATION_TYPES)[number]
export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, string> = {
  TASK_ASSIGNED: 'שויכה אליך משימה',
  TASK_DUE_SOON: 'תאריך יעד מתקרב',
}

/**
 * What a machine token may do. `READ_ONLY` is the default everywhere, so a token
 * created without an explicit choice cannot write.
 */
export const API_TOKEN_SCOPES = ['READ_ONLY', 'READ_WRITE'] as const
export type ApiTokenScope = (typeof API_TOKEN_SCOPES)[number]
export const API_TOKEN_SCOPE_LABELS: Record<ApiTokenScope, string> = {
  READ_ONLY: 'קריאה בלבד',
  READ_WRITE: 'קריאה וכתיבה',
}

export const AUDIT_ENTITY_TYPES = [
  'USER',
  'CLIENT',
  'COMPANY',
  'PROJECT',
  'CONTACT',
  'CASE',
  'CASE_PAYMENT',
  'TASK',
  'TASK_TEMPLATE',
  'DOCUMENT',
  'API_TOKEN',
] as const
export type AuditEntityType = (typeof AUDIT_ENTITY_TYPES)[number]

export const AUDIT_ACTIONS = ['CREATE', 'UPDATE', 'DELETE'] as const
export type AuditAction = (typeof AUDIT_ACTIONS)[number]

/** Where a related row came from when a list merges inherited and direct rows. */
export const LINK_SOURCES = ['project', 'case', 'client', 'task'] as const
export type LinkSource = (typeof LINK_SOURCES)[number]
export const LINK_SOURCE_LABELS: Record<LinkSource, string> = {
  project: 'מהפרויקט',
  case: 'מהתיק',
  client: 'מכרטיס הלקוח',
  task: 'ממשימה',
}
